import { render, staticRenderFns } from "./resumeApplyDialog.vue?vue&type=template&id=84b364d8&scoped=true"
import script from "./resumeApplyDialog.vue?vue&type=script&lang=js"
export * from "./resumeApplyDialog.vue?vue&type=script&lang=js"
import style0 from "./resumeApplyDialog.vue?vue&type=style&index=0&id=84b364d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b364d8",
  null
  
)

export default component.exports